import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../supabase';
import './CreateUser.css';

// Supabase refuses to sign in at all for an unconfirmed email (unlike
// Firebase, which signs in successfully and just exposes emailVerified:
// false) - there's no signed-in session to "reload" here, so checking
// verification means retrying the sign-in itself. If it now succeeds, the
// email is confirmed; sign back out immediately since the real login (OTP
// flow) still needs to happen via LogIn.jsx, not be skipped here.
export default function EmailVerification({ email, password, onVerified }) {
  const { t } = useTranslation('emailVerification');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const resendVerification = async () => {
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/email-verification`, {
        email,
        continueUrl: window.location.origin + '/login',
      });
      setMessage(t('resent'));
    } catch (error) {
      setMessage(t('errorSending', { message: error.response?.data?.error || error.message }));
    }
    setLoading(false);
  };

  const checkVerification = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        setMessage(error.code === 'email_not_confirmed'
          ? t('notVerifiedYet')
          : t('errorChecking', { message: error.message }));
        return;
      }
      if (data.session) await supabase.auth.signOut();
      setMessage(t('verified'));
      onVerified();
    } catch (error) {
      setMessage(t('errorChecking', { message: error.message }));
    }
    setLoading(false);
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h3>{t('title')}</h3>
      <p>{t('sentLinkTo')} <strong>{email}</strong></p>
      <p>{t('clickLinkInstruction')}</p>

      <div style={{ marginTop: '20px' }}>
        <button
          onClick={checkVerification}
          disabled={loading}
          style={{ marginRight: '10px', padding: '10px 20px' }}
        >
          {loading ? t('checking') : t('iHaveVerified')}
        </button>

        <button
          onClick={resendVerification}
          disabled={loading}
          style={{ padding: '10px 20px' }}
        >
          {loading ? t('sending') : t('resendButton')}
        </button>
      </div>

      {message && <p style={{ marginTop: '15px', color: '#20b14c' }}>{message}</p>}
    </div>
  );
}
